export const mountableSteps = {
	title: "Mountable product",
	description:
		"Mountable products allow the end customer to create a combination from a fixed base and a variety of additional ingredients. In the case of açaí, for example, the base would be blended açaí and the additional ingredients would be peanut brittle, milk powder, etc.",
	stepLabel: "Step",
	addStep: "Step",
	removeStep: "Remove step",
	fields: {
		title: {
			label: "Title",
			placeholder: "Enter the step title",
		},
		pricing: {
			label: "Pricing",
			placeholder: "Choose a method",
			options: {
				sum: {
					label: "Additional",
					tooltip: "Every item added will be incremented in the product value",
				},
				average: {
					label: "Average",
					tooltip: "The average of selected items will be incremented",
				},
				higher: {
					label: "Highest value",
					tooltip: "The highest value among items will be added to the product value",
				},
			},
		},
		min: {
			label: "Minimum value",
			tooltip: "Minimum items to be selected",
		},
		max: {
			label: "Maximum value",
			tooltip: "Maximum items to be selected",
		},
	},
	itemsSection: {
		title: "ADDITIONAL INGREDIENTS",
		addItem: "Add another item",
		removeItem: "Remove item",
		fields: {
			item: {
				label: "Item",
				placeholder: "Select an item",
				loadingPlaceholder: "Loading products...",
			},
			price: {
				label: "Price",
			},
			maxCount: {
				label: "Maximum selectable quantity",
				placeholder: "Enter quantity",
				tooltip: "Maximum number of times this item can be selected in the section",
			},
			storageCount: {
				label: "Deducted quantity",
				placeholder: "0",
				tooltip: "Quantity to be deducted from stock per unit",
			},
			isModification: {
				label: "Modification item",
			},
		},
	},
};
